webpackJsonp([35783957827783],{

/***/ 89:
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ }),

/***/ 334:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _meta = __webpack_require__(16);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _gatsbyLink = __webpack_require__(59);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(334);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var metadata = {
	  title: 'Psychologue Clinicienne | Psychologue Montpellier au quartier des arceaux | Morgane Laroche',
	  description: 'Je reçois les adultes en entretien individuels sur rendez-vous, du Lundi au Jeudi. Les consultations ont lieu dans mon cabinet situé au 300 Rue Auguste Broussonnet à Montepllier, à deux pas de l’arrêt de tram Place Albert 1er – Saint Charles.'
	};
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_meta2.default, { title: metadata.title, description: metadata.description }),
	    _react2.default.createElement(
	      'div',
	      { className: 'mea' },
	      _react2.default.createElement(
	        'div',
	        { className: 'mea__slogan' },
	        _react2.default.createElement(
	          'p',
	          { className: 'slogan' },
	          '\xAB Qui mieux que vous sait vos besoins ? Apprendre \xE0 se conna\xEEtre est le premier des soins \xBB'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'u-bold' },
	          'Jean de la Fontaine'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container__block' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'container__block-title' },
	          'ACCUEIL'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'u-paragraphe' },
	          'Il n\u2019est pas rare d\u2019entendre de la part d\u2019un proche :',
	          _react2.default.createElement(
	            'span',
	            { className: 'u-italic' },
	            ' \xAB Je vais voir quelqu\u2019un \xBB'
	          ),
	          '. Mais que se cache-t- il derri\xE8re cette expression ?'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'u-paragraphe' },
	          'Face aux difficult\xE9s que tout individu peut \xEAtre amen\xE9 \xE0 rencontrer au cours de sa vie, il est parfois n\xE9cessaire de demander l\u2019aide d\u2019un professionnel.'
	        ),
	        _react2.default.createElement(
	          'h2',
	          { className: 'u-paragraphe u-text__mea' },
	          'Le',
	          ' ',
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: 'u-text-decoration', to: '/therapie' },
	            'psychologue'
	          ),
	          ' ',
	          'est l\u2019un des professionnels qui peut intervenir lorsque vous traversez une p\xE9riode difficile occasionnant une souffrance, lorsque vous exprimez une volont\xE9 de changement ou plus simplement, le souhait de mieux vous conna\xEEtre.'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'u-paragraphe' },
	          'Il peut vous accompagner dans une',
	          ' ',
	          _react2.default.createElement(
	            'span',
	            { className: 'u-bold' },
	            'difficult\xE9 ponctuelle'
	          ),
	          ' (certains parleraient de \xAB th\xE9rapie de soutien \xBB) en vous aidant \xE0 mobiliser vos ressources psychiques et vos capacit\xE9s d\u2019adaptation.'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'u-paragraphe' },
	          'Il peut \xE9galement vous accompagner dans un processus de',
	          ' ',
	          _react2.default.createElement(
	            'span',
	            { className: 'u-bold' },
	            'changement'
	          ),
	          ' (certains parleraient de \xAB psychoth\xE9rapie \xBB) qui peut s\u2019exprimer de fa\xE7on tr\xE8s diff\xE9rente selon les individus et les situations.'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'u-paragraphe' },
	          'Quelle que soit votre demande, le',
	          ' ',
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: 'u-text-decoration', to: '/therapie' },
	            'psychologue'
	          ),
	          ' ',
	          'vous accueille dans un ',
	          _react2.default.createElement(
	            'span',
	            { className: 'u-bold' },
	            'cadre prot\xE9g\xE9'
	          ),
	          ', vous \xE9coute et vous accompagne dans le respect de la',
	          ' ',
	          _react2.default.createElement(
	            'span',
	            { className: 'u-bold' },
	            'neutralit\xE9'
	          ),
	          ', sans jugement, tout en respectant le principe de',
	          _react2.default.createElement(
	            'span',
	            { className: 'u-bold' },
	            ' confidentialit\xE9'
	          ),
	          '.'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'u-paragraphe' },
	          'Je re\xE7ois \xA0',
	          _react2.default.createElement(
	            'span',
	            { className: 'u-bold' },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { className: 'u-text-decoration', to: '/contacts' },
	              'les adultes'
	            )
	          ),
	          ' ',
	          'en entretiens individuels. Je ne pratique ni la th\xE9rapie de couple ni la th\xE9rapie familiale.'
	        )
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-487379a94517632bedf9.js